import colors from "assets/theme/base/colors";

export const reactSelectStyles = {
    control: (base) => ({
        ...base,
        minHeight: '44px',
        border: '1px solid ' + colors.inputBorderColor,
        borderRadius: '0.375rem',
        fontSize: '14px'
    }),
    menu: (base) => ({
        ...base,
        fontSize: '14px'
    })
};


export const searchBoxStyles = {
    padding: "8px 12px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    height: "44px",
    fontSize: "14px",
};

export const avatarSx = { height: 30, width: 30, fontSize: 14, bgcolor: colors.primary.light, cursor: "pointer" }
